import React from "react";
import {
  Icon,
  IconContainer,
} from "../../../components/visuals/styledComponents";
import { blueText, greyText } from "../../../styles";
import {
  ElementContainer,
  RowContainer,
} from "../../../components/containers/styledComponents";
import { CompassParagraph } from "../../../components/common/styledComponents";

import { getStatus } from "./util";
import { Coverage, Provider } from "../../../models/CompanyprofileModels";
import { LoadingTableCell } from "../../../components/tables/LoadingTableCell";

export const CompanyCoverage = ({
  coverage,
  isLoading = false,
}: {
  coverage: Record<Provider, Coverage>;
  isLoading?: boolean;
}): JSX.Element => {
  return (
    <RowContainer jc="flex-start" ai="center" ml={-10}>
      {Object.keys(coverage)
        .filter((provider) => coverage[provider as Provider].title !== "")
        .map((provider) => {
          const { isCovered, title } = coverage[provider as Provider];
          const status = getStatus(isCovered);

          return isLoading ? (
            <LoadingTableCell key={provider} dark={true} ml={1} />
          ) : (
            <React.Fragment key={provider}>
              <IconContainer size={35}>
                <Icon src={status.checkbox} alt={title} />
              </IconContainer>
              <ElementContainer flexDirection="column">
                <CompassParagraph fontSize={12} color={blueText}>
                  {title}
                </CompassParagraph>
                <CompassParagraph fontSize={11} color={greyText}>
                  {status.title}
                </CompassParagraph>
              </ElementContainer>
            </React.Fragment>
          );
        })}
    </RowContainer>
  );
};
